import { render, staticRenderFns } from "./SideBar_Sponsor.vue?vue&type=template&id=4c29f4b9&scoped=true&"
import script from "./SideBar_Sponsor.vue?vue&type=script&lang=js&"
export * from "./SideBar_Sponsor.vue?vue&type=script&lang=js&"
import style0 from "./SideBar_Sponsor.vue?vue&type=style&index=0&id=4c29f4b9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c29f4b9",
  null
  
)

export default component.exports